import * as React from 'react';
import { render, MARK_LINK } from 'storyblok-rich-text-react-renderer';
import clsx from 'clsx';
import FancyTitle from '../fancy-title';
import { useModals } from '../../contexts/ModalContext';
import LinkResolver from '../../helpers/link-resolver';
import StoryBlokLink from './StoryBlokLink';
import PipedriveForm from '../pipedrive-form';

const imageSizes = {
  SMALL: 200,
  BASE: 400,
  LARGE: 600,
};

const imageColSizes = {
  SMALL: 3,
  BASE: 4,
  LARGE: 6,
};

export default function ContactBlock(blok) {
  const {
    title,
    button_text: buttonText,
    body,
    image,
    image_size: imageSelectedSize,
    button_target: buttonTarget,
    circular_image: circularImage,
    popup_title: popupTitle,
    popup_subtitle: popupSubtitle,
    popup_description: popupDescription,
  } = blok;

  const imageSize = imageSizes[imageSelectedSize];
  const imageColSize = imageColSizes[imageSelectedSize];

  const { createId, openModal } = useModals();
  return (
    <div>
      <div className="grid grid-cols-12">
        <div className="block xl:hidden col-span-full">
          <FancyTitle
            marginBottom="mb-0"
            tag="h2"
            text={title}
          />
        </div>
        <div className={clsx(
          'col-span-12 text-center',
          `xl:col-span-${imageColSize}`,
        )}
        >
          <img
            src={image.filename}
            alt={image.alt}
            height={imageSize}
            width={imageSize}
            style={{
              maxWidth: `${imageSize}px`,
              maxHeight: `${imageSize}px`,
            }}
            className={clsx(
              'ml-auto mr-auto w-full object-cover xl:mb-0 mb-4 block mt-0 xl:max-h-[unset] xl:max-w-[unset]',
              circularImage ? 'rounded-full aspect-square xl:mt-16' : 'h-full xl:mt-0',
            )}
          />
        </div>
        <div className={clsx(
          'col-span-12',
          `xl:col-span-${12 - imageColSize}`,
        )}
        >
          <div className="xl:px-8 py-8">
            <FancyTitle
              className="mb-8 hidden xl:block"
              tag="h2"
              text={title}
            />
            <div>
              {render(body, {
                markResolvers: {
                  [MARK_LINK]: LinkResolver,
                },
              })}
            </div>
            { (!buttonTarget || !buttonTarget.url) && (
              <button
                onClick={() => {
                  const id = createId();
                  openModal({
                    id,
                    body: <PipedriveForm
                      title={popupTitle}
                      subtitle={popupSubtitle}
                      text={popupDescription}
                    />,
                  });
                }}
                type="button"
                className="button-primary mt-8"
              >
                {buttonText}
              </button>
            )}
            { (buttonTarget && buttonTarget.url) && (
              <StoryBlokLink
                className="button-primary inline-block no-underline mt-8"
                link={buttonTarget}
              >
                {buttonText}
              </StoryBlokLink>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
